import React from 'react';
import { IRequestsReorderDetail } from './_types';
import { StudiesReorderDetail } from 'modules/Studies/StudiesReorder/StudiesReorderDetail';

const RequestsReorderDetail: React.FC<IRequestsReorderDetail> = () => (
  <StudiesReorderDetail isRequest={true} />
);

export default RequestsReorderDetail;
